import React from 'react';
import styled, { withTheme } from 'styled-components';
import { FormattedMessage } from 'react-intl';

import { Question } from '@zocdoc/components/src/icons';
import { linkStyle } from '@zocdoc/components/src/link';
import { breakpoint } from '@zocdoc/components/src/grid';
import { filterToValidAttributes } from '@zocdoc/dom-property';

const CallToAction = styled.span`
    cursor: pointer;
`;

const StyledWhoAccept = styled.span`
    margin-right: 10px;
`;

const StyledQuestionIcon = styled(Question)`
    font-size: 20px;
    vertical-align: text-bottom;
    margin-right: 11px;
`;

const CtaText = styled.span`
    ${linkStyle};
    color: ${p => p.theme.components.InsuranceCta.textColor};
`;

const MobileAndDesktopCtaText = styled(CtaText)`
    ${breakpoint('small', { only: true })} {
        display: none;
    }
`;

const TabletCtaText = styled(CtaText)`
    ${breakpoint('xsmall', { down: true })} {
        display: none;
    }

    ${breakpoint.medium} {
        display: none;
    }
`;

const InsuranceCta = ({
    children, onClick, theme, ...props
}) => (
    <span {...filterToValidAttributes(props)}>
        &nbsp;
        <StyledWhoAccept>
            <FormattedMessage
                defaultMessage="who accept"
                id="Search.InsuranceCta.WhoAccept"
            />
        </StyledWhoAccept>

        <CallToAction onClick={onClick}>
            <StyledQuestionIcon color={theme.components.InsuranceCta.iconColor} />
            <MobileAndDesktopCtaText>
                <FormattedMessage
                    defaultMessage="enter your insurance to view in-network doctors"
                    id="Search.InsuranceCta.EnterInsurance"
                />
            </MobileAndDesktopCtaText>
            <TabletCtaText>
                <FormattedMessage
                    defaultMessage="tap to enter your insurance to view in-network doctors"
                    id="Search.InsuranceCta.EnterInsurance.Tablet"
                />
            </TabletCtaText>
        </CallToAction>
    </span>
);

export default withTheme(InsuranceCta);
